import { useEffect, useMemo, useState } from "react"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store"
import { validacaoValorServicoMinimo } from "../../utils/validarValorServicoMinimo"

interface ValorServicoInputProps {
  servicoObrigatorio: boolean
}

export const ValorServicoInput = ({ servicoObrigatorio }: ValorServicoInputProps) => {
  const permissoes = PermissionUtil.getPermissions();
  const { valor_servico, valor_minimo_servico, isEdit, tipo_proposta } = useProjetosOffGridStore((store) => store.state.data)
  const { changeValue } = useProjetosOffGridStore((store) => store.actions)

  const [valorServico, setValorServico] = useState(valor_servico)

  useEffect(()=>{
    if (!tipo_proposta || tipo_proposta?.value === 'gerador-sem-instalacao') {
      setValorServico(0)
    }
  },[tipo_proposta])

  const useValorMinimoServico = useMemo(() => {
    return (valor_servico || 0) > 0 ? valor_minimo_servico > 0 && validacaoValorServicoMinimo((valor_servico || 0), valor_minimo_servico, permissoes) ? 0 : valor_minimo_servico : 0
  },[permissoes, valor_minimo_servico, valor_servico])

  return (
    <InputDecimal3
      InputLabelProps={{ shrink: true }}
      label={`${servicoObrigatorio ? '*' : ''} Valor do serviço líquido (R$)`}
      margin="normal"
      disabled={!servicoObrigatorio}
      decimal={2}
      maxLength={15}
      prefix={valorServico ? <>R$&nbsp;</> : ''}
      placeholder="R$ 0,00"
      helperText={useValorMinimoServico && valor_minimo_servico > Number(valorServico) ? `Para inserir o valor de serviço na plataforma o valor mínimo tem que ser de ${Intl.NumberFormat('pt-BR', { style: "currency", currency: "BRL" }).format(valor_minimo_servico)}` : ''}
      value={String(valorServico || '')}
      onChange={(event: any) => {
        const normalized = event.target.value ? event.target.value.replace(',', '.') : '0'
        setValorServico(normalized)
      }}
      onBlur={() => {
        changeValue({ valor_servico: Number(valorServico), recalcular: isEdit })
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "-") {
          event.preventDefault();
        }
      }}
      InputProps={{
        onInput: (event: any) => {
          const value = event.target.value
          const cleanedText = value.replace(/-/g, '');
          event.target.value = cleanedText
        }
      }}
    />
  );
}